module.exports = __webpack_public_path__ + "img/image-placeholder-square.6266567a.svg";